import React from 'react';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';
import { DescriptionWithImageProps } from './DescriptionWithImageProps';
import * as styles from './DescriptionWithImage.module.scss';

export const DescriptionWithImage: React.FC<DescriptionWithImageProps> = ({
	children,
	image,
	className = 'white-bg',
	contentClassName,
	imageClassName = styles.img,
	imageBoxClassName,
	imageOnRight = false,
	disableContentPadding = false,
}) => {
	return (
		<PaddingContainer className={className}>
			<WidthContainer
				className={classNames(
					styles.container,
					imageOnRight && styles.imageOnRight
				)}
			>
				<div
					className={classNames(
						'row no-gutters',
						!imageOnRight && 'flex-row-reverse'
					)}
				>
					<div className={classNames('col-12 col-md-6', contentClassName)}>
						<div
							className={classNames(
								styles.content,
								disableContentPadding && 'px-0'
							)}
						>
							{children}
						</div>
					</div>
					<div
						className={classNames(
							imageBoxClassName,
							'col-12 col-md-6 d-flex align-items-center pt-5 pt-md-0'
						)}
					>
						<img className={imageClassName} src={image} />
					</div>
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
